import { FeaturesSetupState } from '@layout/features-setup/store/states/features-setup.state';

export const featuresSetupState = [FeaturesSetupState];
